import type {SearchRules} from '../../types';
import {SearchTypeCustom} from '../constants';
import {rulesContainCustom} from './rulesContainCustom';

const LATEST_THINGS = [
	'latestDocuments',
	'latestImages',
	'latestUploads',
	'latestVideos',
];

export const rulesContainCustomLatestThing = (
	searchRules: Partial<SearchRules>,
) => {
	if (!rulesContainCustom(searchRules)) return false;
	return (
		!!searchRules.elementTypes &&
		searchRules.elementTypes.some(
			(elementType, index) =>
				elementType === SearchTypeCustom &&
				LATEST_THINGS.includes(
					searchRules.elementValue1s?.[index] as unknown as string,
				),
		)
	);
};
